export async function getBase64ImageFromUrl(imageUrl) {
  let res
  try {
    res = await fetch(imageUrl)
  } catch (error) {
    throw error
  }

  let blob
  try {
    blob = await res.blob()
  } catch (error) {
    throw error
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.addEventListener(
      'load',
      function () {
        resolve(reader.result)
      },
      false
    )

    reader.onerror = () => {
      return reject(this)
    }
    reader.readAsDataURL(blob)
  })
}
